
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","stroke":"#FFF","fill":"none","stroke-linecap":"round"}},[_c('path',{attrs:{"stroke-linejoin":"bevel","stroke-width":"2","d":"M22.941 13.79v-3.639l-2.714-1.164a43.215 43.215 0 00-.31-.743l1.1-2.745-2.575-2.574-2.744 1.1a36.481 36.481 0 01-.743-.31L13.79 1h-3.639L8.987 3.715c-.287.117-.457.187-.743.31l-2.745-1.1-2.574 2.574 1.1 2.745c-.117.286-.187.456-.304.737L1 10.145v3.64l2.72 1.17.305.737-1.1 2.744 2.574 2.575 2.75-1.1c.281.117.457.187.738.304l1.164 2.72h3.64"}}),_c('path',{attrs:{"stroke-linejoin":"round","stroke-width":"1.5","d":"M22.298 19.197l-6.109-6.115c.387-1.462.024-3.077-1.123-4.224-1.147-1.147-2.762-1.51-4.225-1.123l2.674 2.674-3.1 3.1-2.675-2.672c-.386 1.462-.023 3.077 1.124 4.224 1.147 1.147 2.762 1.51 4.224 1.124l6.115 6.114a2.196 2.196 0 003.1 0h0a2.19 2.19 0 00-.005-3.101z"}})])])
          )
        }
      }
    